/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.6.27",
    versionName: "0.2.0-nightly.2025.6.27",
    versionChannel: "nightly",
    buildDate: "2025-06-27T00:08:13.943Z",
    commitHash: "794e41b122674456089e4e8bbb22f4d32bdcac03",
};
